import { render, staticRenderFns } from "./TagsNav.vue?vue&type=template&id=55f3c68e"
import script from "./TagsNav.vue?vue&type=script&lang=js"
export * from "./TagsNav.vue?vue&type=script&lang=js"
import style0 from "./TagsNav.vue?vue&type=style&index=0&id=55f3c68e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports